import { Component, OnInit, EventEmitter, Output, OnDestroy } from '@angular/core';
import { BaseComponent } from '../../base.component';
import { UntypedFormBuilder, UntypedFormGroup, Validators, AbstractControl } from '@angular/forms';
import { RoleService } from '../../_services/role.service';

import { ClientService } from '../../_services/client.service';
import { UserUpdate, ClientInfoForUserAdd } from '../../_models/index';
import { ClientDataHelper } from '../../_helpers/client-data-helper';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ErrorModalHelperService } from '../../_helpers/error-modal-helper/error-modal-helper.service';
import { SuccessModalHelperService } from '../../_helpers/success-modal-helper/success-modal-helper.service';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'add-update-user',
    templateUrl: 'add-update-user.html',
    styleUrls: ['add-update-user.css'],
    standalone: false
})

export class ClientUserComponent extends BaseComponent implements OnInit, OnDestroy {
  clientList: any[] = [];
  @Output() onClosed: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDataSaved: EventEmitter<any> = new EventEmitter<any>();

  private unsubscribe: Subject<void> = new Subject<void>();

  frmClientUser: UntypedFormGroup;
  loading: boolean = false;
  mobNumberPattern = "^((\\+91-?)|0)?[0-9]{10}$";
  displayedColumns: string[] = ['clientname', 'role'];
  userDetails: any = [];
  userRoles: any = [];
  dataSource: MatTableDataSource<ClientInfoForUserAdd> = new MatTableDataSource<ClientInfoForUserAdd>([]);
  selectedClientIds: number[] = [];
  selectedRoles: any = [];
  yesRoles: AbstractControl;
  noRoles: AbstractControl;
  edit: boolean = false;
  userId: number;
  errorMsg: string;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private roleSerive: RoleService,
    private clientService: ClientService,
    private successModalHelper: SuccessModalHelperService,
    //private userService: UserService,
    private clientDataHelper: ClientDataHelper,
    private errorModalHelper: ErrorModalHelperService) {
    super();
    this.frmClientUser = this.formBuilder.group({
      firstName: [null, Validators.required],
      lastName: [null, Validators.required],
      email: [null, Validators.required],
      mobileNumber: [null],
      chkClientRolesAccessYes: [false],
      chkClientRolesAccessNo: [false],
      mfaEnabled: [false]
    });

    const mobileNumber = this.frmClientUser.get("mobileNumber");
    this.frmClientUser.get("mfaEnabled").valueChanges.pipe(takeUntil(this.unsubscribe)).subscribe(isMfaEnabled => {

      if (isMfaEnabled) {
        mobileNumber.setValidators([Validators.required]);
        mobileNumber.updateValueAndValidity();
      } else {
        mobileNumber.setValidators(null);
        mobileNumber.setErrors(null);
        mobileNumber.updateValueAndValidity();
      }
    });

  }

  ngOnInit() {
    this.clientService.GetClients(this.authService.userSessionData.currentUser.id).subscribe((data: ClientInfoForUserAdd[]) => {
      data.forEach(item => item.disableReferral = true);
      this.clientList = data;
      this.clientList.forEach(c => c.dropdownDisplay = c.clientName + " ID: " + c.clientId);
      this.dataSource.data = this.clientList;
    }, error => {
      this.errorModalHelper.show(error.message, error);
    });

    this.roleSerive.GetClientRoles().subscribe((data: any) => {
      // 35747: Tuition Works (ASSESSOR) is the legacy marketing tuition flow — not assignable here.
      data = data.filter(clientRole => clientRole.roleCode !== 'ASSESSOR');
      this.userRoles = data.sort((n1, n2) => {
        if (n1.role > n2.role) {
          return 1;
        }
        if (n1.role < n2.role) {
          return -1;
        }
        return 0;
      });
    }, error => {
      this.errorModalHelper.show(error.message, error);
    });

    this.yesRoles = this.frmClientUser.get('chkClientRolesAccessYes');
    this.noRoles = this.frmClientUser.get('chkClientRolesAccessNo');
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  submit() {
    this.onDataSaved.emit(true);
  }

  close() {
    this.onClosed.emit(true);
  }


  tosslePerOne(all) {

  }

  toggleAllSelection() {

  }

  saveUser() {
    this.errorMsg = '';
    if (!this.frmClientUser.valid) {
      return;
    }

    var roleSelected = false
    var user = new UserUpdate();
    user = this.frmClientUser.value;
    user.username = user.email;
    user.hasMultipleRoles = false;
    user.roleCode = "CLIENT";
    user.applicationUsers = [];
    user.applicationType = 'client';
    user.parentUserId = this.authService.userSessionData.currentUser.id;

    user.roles = new Array<number>();
    this.clientList.forEach(x => {
      x.currentRoles = this.selectedRoles.filter(y => y.clientId == x.clientId);
      if (x.currentRoles.length > 0) {
        x.currentRoles.forEach(r => {
          // No applicationId: a brand is the client's, not the creator's. CreateClientUserAccount
          // stamps the linked client's own brand on the ApplicationUser (TutorPortalAPI PRs 6332/6335).
          user.applicationUsers.push({ externalApplicationUserId: x.clientId });
          user.roles.push(+r.roleId)

          if (!roleSelected) {
            roleSelected = true;
          }
        });
      }
    });

    if (!roleSelected) {
      this.errorMsg = "Atleast one client/role should be selected";
      return;
    }

    if (this.edit) {
      user.id = this.userId;
      this.updateUser(user);
    }
    else {
      this.createUser(user);
    }
  }

  createUser(user) {
    this.userService.createClientUser(user).subscribe(
      data => {
        this.saveRoles(user);
      },
      error => {
        this.errorModalHelper.show(error.message, error);
      });
  }

  updateUser(user) {
    this.userService.updateUser(user).subscribe(
      data => {
        this.saveRoles(user);
      },
      error => {
        this.errorModalHelper.show(error.message, error);
      });
  }

  saveRoles(user) {
    this.populateSelectedRoles();
    var clientsData = {
      clientUserClients: this.clientList,
      allRolesSelected: this.frmClientUser.value.chkClientRolesAccessYes,
      allRolesSelectedNo: this.frmClientUser.value.chkClientRolesAccessNo,
      userName: user.username,
      createdBy: user.parentUserId
    };

    if (this.edit) {
      this.clientService.UpdateClientUsers(clientsData).subscribe(result => {
        this.successModalHelper.show("Client access details updated");
        this.clientService.SendEmailsToClientUsers(clientsData).subscribe(data => {
        });
        this.onDataSaved.emit(true);
      },
        error => {
          this.errorModalHelper.show(error.message, error);
        })
    }
    else {
      this.clientService.CreateClientUsers(clientsData).subscribe(result => {
        this.successModalHelper.show("Client access details created");
        this.onDataSaved.emit(true);
      },
        error => {
          this.errorModalHelper.show(error.message, error);
        })
    }
  }

  populateSelectedRoles() {
    var roleSelected = false
    this.clientList.forEach(x => {
      x.currentRoles = this.selectedRoles.filter(y => y.clientId == x.clientId);
    })
  }

  assignCheckbox(row: ClientInfoForUserAdd, chk, event) {
    for (var i = 0; i < this.selectedRoles.length; i++) {
      let selectedData = this.selectedRoles[i].id === row.id && this.selectedRoles[i].roleId === chk.id;
      if (selectedData) {
        this.selectedRoles.splice(i, 1);
        i--;
      }
    }
    this.selectedRoles.push({ id: row.id, roleId: chk.id, selected: event.checked, clientId: row.clientId, userId: row.userId });

    if (chk.role == "Reports") {
      row.disableReferral = !event.checked;
      if (!event.checked) {
        row.viewReferrals = false;
      }
    }

  }

  onAllRolesChanged(event) {
    if (this.frmClientUser.value.chkClientRolesAccessYes) {
      this.selectedRoles = [];
      this.clientList.forEach((x) => {
        var disabled = [];
        this.userRoles.forEach(y => {
          var result = this.getDisabledRoles(x, y);
          if (!result) {
            disabled.push(y.id);
          }
        });
        x.roles = disabled;
        x.roles.forEach((y) => {
          this.selectedRoles.push({ id: x.id, roleId: y, selected: true, clientId: x.clientId, userId: x.userId });
        })
      })
    }
    else {
      this.selectedRoles.forEach(x => {
        x.selected = false;
      });

      if (this.edit) {
        this.clientList.forEach((x) => {
          x.roles = [];
        })
      }
    }
  }

  checked(row, chk) {
    if (row && row.roles && (this.edit || this.frmClientUser.value.chkClientRolesAccessYes)) {
      var role = row.roles.find(x => x === chk.id);
      if (role != null) {
        return true;
      }
    }
    return false;
  }

  onDisabled(row, chk) {
    if (this.authService.userSessionData.currentUser.parentUserId == null) {
      return false;
    }
    return this.getDisabledRoles(row, chk);
  }

  getDisabledRoles(row, chk) {
    var userClient = this.userDetails.find(x => x.clientId === row.clientId);
    if (userClient != null) {
      if (row.adminRoleId) {
        return false;
      }
      var role = userClient.roles.find(x => x === chk.id);
      if (role == null) {
        return true;
      }
    }
    return false;
  }

  assignReferrals(row, event) {
    this.clientList.find(x => x.clientId === row.clientId).viewReferrals = event.checked;
  }

  public onClientFilterChange(selectedClientIds: number[]): void {
    this.selectedClientIds = selectedClientIds || [];
    this.dataSource.filterPredicate = (data: ClientInfoForUserAdd) =>
      this.selectedClientIds.some(id => String(id) === String(data.clientId));
    // empty string => MatTableDataSource shows all rows; non-empty => predicate runs
    this.dataSource.filter = this.selectedClientIds.length ? this.selectedClientIds.join(',') : '';
  }
}
